module.exports = __webpack_public_path__ + "static/media/hull_color_style_0005.ec9cc373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0005.jpg
// module id = 623
// module chunks = 0